import { Skeleton } from '@mui/material';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { forwardRef, ReactElement, ReactNode, Ref } from 'react';

interface Props extends TypographyProps {
  children?: ReactNode;
  truncate?: boolean;
  formLike?: boolean | string;
  loading?: boolean;
}

const getTruncateSx = (truncate?: boolean) => {
  return truncate
    ? {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        width: 'inherit',
        overflow: 'hidden',
        textAlign: 'start',
        maxWidth: '100%'
      }
    : ({} as any);
};

const getFormLikeSx = (formLike?: boolean | string) => {
  return formLike
    ? { bgcolor: formLike === true ? 'common.white' : formLike, borderRadius: '5px', p: '5px', minHeight: '35px' }
    : ({} as any);
};

function TypographyComponent(
  { children, truncate, sx, loading, formLike, ...rest }: Props,
  ref: Ref<HTMLSpanElement>,
): ReactElement {
  if (loading) {
    return <Skeleton height={55} width="80%"></Skeleton>;
  }
  return (
    <Typography ref={ref} {...rest} sx={{ ...getTruncateSx(truncate), ...getFormLikeSx(formLike), ...sx }}>
      {children}
    </Typography>
  );
}

export default forwardRef<HTMLSpanElement, Props>(TypographyComponent);
